<div class="gw-flex gw-items-center gw-gap-3">
  <tui-avatar
    *ngIf="photo && receiverName"
    [src]="receiverName | tuiInitials"
    [size]="size === 's' ? 's' : size === 'l' ? 'l' : 'm'"
    [style.color]="'var(--tui-text-primary-on-accent-1)'"
    class="gw-flex-shrink-0 gw-avatar-bg g"
    tuiAvatarOutline
  ></tui-avatar>

  <div class="gw-flex gw-flex-col gw-min-w-0 gw-flex-1">
    <span
      *ngIf="displayName"
      [class.gw-text-sm]="smallFont"
      class="gw-text-text-primary gw-font-semibold gw-truncate"
    >
      {{ displayName }}
    </span>
    <span
      *ngIf="hasPixKey"
      class="gw-text-xs gw-text-text-secondary gw-truncate"
    >
      {{ pixKey | pixKey : pixKeyType }}
    </span>
    <span *ngIf="bankName" class="gw-text-xs gw-text-text-tertiary gw-truncate">
      {{ bankName }}
    </span>
    <span
      *ngIf="agencyLine"
      class="gw-text-xs gw-text-text-tertiary gw-truncate"
    >
      {{ agencyLine }}
    </span>
    <span
      *ngIf="accountLine"
      class="gw-text-xs gw-text-text-tertiary gw-truncate"
    >
      {{ accountLine }}
    </span>
  </div>
</div>
